import React from "react";
import Img from "gatsby-image";
import classNames from "classnames";
import { CTAButton } from "./CTAButton";

type Image = {
  publicURL: string;
  childImageSharp?: {
    fluid: any;
  };
};

type Navigation = {
  label: string;
  url: string;
  type: "primary" | "outline" | "link";
  opensInNewTab: boolean;
};

type CoverLargeProps = {
  title: string;
  description: string;
  //   coverUrl: Image;
  coverUrl: Image;
  navigation: Navigation[];
  coverSize: "small" | "medium" | "large";
  contentAlignment: "left" | "center";
  textStyle: "light" | "dark";
  readabilityOverlay: boolean;
  image: Image;
};

const CoverLarge: React.FC<CoverLargeProps> = ({
  title,
  description,
  coverUrl,
  navigation,
  textStyle,
  readabilityOverlay,
  image,
  contentAlignment,
}) => {
  return (
    <section
      style={{ overflow: "hidden" }}
      className={classNames(
        "bg-cover bg-center max-w-full relative flex flex-col"
      )}
    >
      <div className="absolute inset-0">
        {coverUrl?.childImageSharp && (
          <Img
            className="h-full"
            fadeIn={false}
            loading="eager"
            fluid={coverUrl.childImageSharp.fluid}
          />
        )}
        {!coverUrl?.childImageSharp && coverUrl?.publicURL && (
          <img
            className="w-full h-full object-cover"
            src={coverUrl?.publicURL}
            alt=""
          />
        )}
      </div>
      {/* <div className="relative flex items-center py-20 lg:py-32"> */}
      <div
        className={classNames("relative flex items-center", {
          "py-20 lg:py-32": coverUrl,
          "py-10": !coverUrl,
        })}
      >
        <div
          className={classNames("absolute inset-0", {
            "bg-black opacity-70":
              coverUrl && readabilityOverlay && textStyle === "light",
            "bg-white opacity-70":
              coverUrl && readabilityOverlay && textStyle === "dark",
            "bg-white": !coverUrl,
          })}
        />
        <div
          className={classNames("z-10 container mx-auto px-6", {
            "items-center text-center": contentAlignment === "center",
            "items-start": contentAlignment === "left",
          })}
        >
          {image?.childImageSharp && (
            <Img
              className={classNames("mb-4 w-24 md:w-32 h-auto", {
                "mx-auto": contentAlignment === "center",
              })}
              fadeIn={false}
              loading="eager"
              fluid={image.childImageSharp.fluid}
            />
          )}
          {!image?.childImageSharp && image?.publicURL && (
            <img
              className={classNames("mb-4 w-24 md:w-32 h-auto", {
                "mx-auto": contentAlignment === "center",
              })}
              src={image.publicURL}
              alt=""
            />
          )}

          <h1
            className={classNames(
              "dangerous-html mb-2 text-2xl lg:text-4xl leading-tight font-sansBold break-words",
              {
                "text-white": textStyle === "light" && coverUrl,
                "text-gray-800": textStyle === "dark" || !coverUrl,
              }
            )}
          >
            {title}
          </h1>
          <div
            dangerouslySetInnerHTML={{
              __html: `<div>${description}</div>`,
            }}
            className={classNames(
              "max-w-2xl dangerous-html text-lg lg:text-xl font-serifLight opacity-85 dangerous-html",
              {
                "text-white": textStyle === "light" && coverUrl,
                "text-gray-800": textStyle === "dark" || !coverUrl,
                "text-center mx-auto": contentAlignment === "center",
              }
            )}
          ></div>
          {navigation?.length > 0 && (
            <div
              className={classNames("flex flex-wrap items-center", {
                "justify-center": contentAlignment === "center",
              })}
            >
              {navigation.map((button, index) => {
                return (
                  <div
                    key={index}
                    className={classNames(
                      "mt-5",
                      {
                        "mr-4":
                          contentAlignment === "left" &&
                          navigation?.length > 1 &&
                          index !== navigation?.length - 1,
                      },
                      {
                        "mx-2":
                          contentAlignment === "center" &&
                          navigation?.length > 1,
                      }
                    )}
                  >
                    <CTAButton
                      type={button.type}
                      label={button.label}
                      opensInNewTab={button.opensInNewTab}
                      url={button.url}
                      textStyle={coverUrl ? textStyle : "dark"}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      {!coverUrl && <hr className="container mx-auto" />}
    </section>
  );
};

export default CoverLarge;
